import { useEffect } from "react";
import { Inbox } from "@/components/account/inbox";
import Layout from "@/components/app/layout/index";
import { RestrictedAccountRoute } from "@/components/restrict";
import { useSelector } from "@/redux";
import { useAccountDispatch } from "@/redux/me/use-account";
import { userLoggedIn } from "@/utils/auth";

export default function InboxPage() {
  const { dispatch, fetchMessages } = useAccountDispatch();
  const messages = useSelector((state) => state.app.me.messages);

  useEffect(
    function () {
      if (userLoggedIn()) {
        dispatch(fetchMessages());
      }
    },
    [dispatch, fetchMessages]
  );

  return (
    <RestrictedAccountRoute>
      <Layout backgroundOverride={true}>
        <Inbox messages={messages} />
      </Layout>
    </RestrictedAccountRoute>
  );
}
